import { get, put, del } from 'services/client'

const fetchUserInfo = (userId, token = '') =>
  get(`users/${userId}/info`, token ? { Authorization: `Bearer ${token}` } : {})

const fetchCompanyInfo = (locale = '') =>
  get(
    `procurements/profile`,
    locale && locale.length > 0 ? { 'Content-Language': locale } : {},
  )

const updateUserActiveModule = (userId, token = '') =>
  put(
    `users/${userId}/modules/homologation/active`,
    {},
    token ? { Authorization: `Bearer ${token}` } : {},
  )

const storeAccessToken = token => {
  try {
    localStorage.setItem('access_token', token)
  } catch (err) {
    console.error('Error setting access_token on localStorage')
    throw err
  }
}

const getStoredAccessToken = () => {
  try {
    return localStorage.getItem('access_token')
  } catch (err) {
    console.error('Error setting access_token on localStorage')
    throw err
  }
}

const deleteStoredAccessToken = () => {
  try {
    return localStorage.removeItem('access_token')
  } catch (err) {
    console.error('Error removing access_token on localStorage')
    throw err
  }
}

const storeRefreshToken = token => {
  try {
    localStorage.setItem('refresh_token', token)
  } catch (err) {
    console.error('Error setting refresh_token on localStorage')
    throw err
  }
}

const getStoredRefreshToken = () => {
  try {
    return localStorage.getItem('refresh_token')
  } catch (err) {
    console.error('Error setting refresh_token on localStorage')
    throw err
  }
}

const deleteStoredRefreshToken = () => {
  try {
    return localStorage.removeItem('refresh_token')
  } catch (err) {
    console.error('Error removing refresh_token on localStorage')
    throw err
  }
}

const storeIdToken = token => {
  try {
    localStorage.setItem('id_token', token)
  } catch (err) {
    console.error('Error setting id_token on localStorage')
    throw err
  }
}

const getStoredIdToken = () => {
  try {
    return localStorage.getItem('id_token')
  } catch (err) {
    console.error('Error getting id_token on localStorage')
    throw err
  }
}

const deleteStoredIdToken = () => {
  try {
    return localStorage.removeItem('id_token')
  } catch (err) {
    console.error('Error removing id_token on localStorage')
    throw err
  }
}

const logout = () => {
  try {
    localStorage.removeItem('user')
  } catch (err) {
    console.error('Error removing user on localStorage')
  }
}

const logoutEndpoint = token =>
  del('users/authentications', {}, { Authorization: `Bearer ${token}` })

export {
  fetchUserInfo,
  updateUserActiveModule,
  storeAccessToken,
  fetchCompanyInfo,
  getStoredAccessToken,
  deleteStoredAccessToken,
  logout,
  logoutEndpoint,
  storeRefreshToken,
  getStoredRefreshToken,
  deleteStoredRefreshToken,
  storeIdToken,
  getStoredIdToken,
  deleteStoredIdToken,
}
